import { ArrowRight } from "lucide-react";

import type { Exercise } from "../api/types";
import { Banner } from "../components/Callout";
import { Presence } from "../components/presence";
import { Button } from "../components/ui";
import { t } from "../i18n/i18n";
import { useUi } from "../state/ui";
import { storedDraftFor } from "./missionDraft";

/** Rappel, dans les documents tirés du dossier (OPO, dossier d'exercice), qu'une saisie des Données initiales
 *  attend d'être enregistrée sur ce poste (audit de persistance m11) : le document ne la reprend pas encore. Le
 *  bouton mène à l'action attendue, « Enregistrer » des Données initiales. */
export function PendingMissionDraftBanner({ exercise }: { exercise: Exercise | undefined }) {
  const setView = useUi((s) => s.setView);
  const pending = Boolean(exercise && storedDraftFor(exercise));
  return (
    <Presence show={pending}>
      {pending && (
        <Banner
          tone="info"
          actions={
            <Button size="sm" variant="secondary" onClick={() => setView("mission")}>
              {t("Voir les Données initiales")} <ArrowRight size={14} />
            </Button>
          }
        >
          {t("Des modifications des Données initiales ne sont pas enregistrées : ce document ne les reprend pas encore.")}
        </Banner>
      )}
    </Presence>
  );
}
